import { CalendarItemType } from '@akin-home/amplify';

export const api_query_keys: Record<CalendarItemType, string> = {
  Alarm: 'alarms',
  Alert: 'alerts',
  Event: 'events',
  Meal: 'meals',
  Goal: 'goals',
};
